import { Routes, RouterModule } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { SiginComponent } from './sigin/sigin.component';
import { RoomenquiryComponent } from './pghouses/roomenquiry/roomenquiry.component';



export const AppRoutes: Routes = [
    { path: 'roomenquiry', component: RoomenquiryComponent },
    //{ path: '/layouts/full', component: FullComponent },
    { path: 'dashboard', component: FullComponent },
    
  {
  path: '',
    component: FullComponent,
    children: [
      {
      path: '',
      redirectTo: '/Pghouses/roomenquiry',
      pathMatch: 'full'
    },
    { 
      path: 'dashboards',
      loadChildren: () => import('./dashboards/dashboards.module').then(x => x.DashboardsModule)
   },
   {
    path: 'Pghouses',
    //loadChildren: './Pghouses/Pghouses.module#PghousesModule'
    loadChildren: () => import('./pghouses/pghouses.module').then(mod => mod.PghousesModule),
  }
    
     
     
      
    ]
}];
